const REFRESH_MARGIN_S = 120;
export const MIN_DELAY_S = 30;

// Scheduled off expires_in (seconds until expiry, as measured by the server)
// rather than the expiry timestamp, so browser/server clock skew can't cause
// a premature or missed refresh.
export function refreshDelaySeconds(expiresIn) {
    return Math.max(expiresIn - REFRESH_MARGIN_S, MIN_DELAY_S);
}
